/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDeliveryDriverRequestDeliveryDriver
 */
export interface CreateDeliveryDriverRequestDeliveryDriver {
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryDriverRequestDeliveryDriver
     */
    shippingDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryDriverRequestDeliveryDriver
     */
    handle: string;
}

/**
 * Check if a given object implements the CreateDeliveryDriverRequestDeliveryDriver interface.
 */
export function instanceOfCreateDeliveryDriverRequestDeliveryDriver(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "shippingDate" in value;
    isInstance = isInstance && "handle" in value;

    return isInstance;
}

export function CreateDeliveryDriverRequestDeliveryDriverFromJSON(json: any): CreateDeliveryDriverRequestDeliveryDriver {
    return CreateDeliveryDriverRequestDeliveryDriverFromJSONTyped(json, false);
}

export function CreateDeliveryDriverRequestDeliveryDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeliveryDriverRequestDeliveryDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shippingDate': json['shipping_date'],
        'handle': json['handle'],
    };
}

export function CreateDeliveryDriverRequestDeliveryDriverToJSON(value?: CreateDeliveryDriverRequestDeliveryDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shipping_date': value.shippingDate,
        'handle': value.handle,
    };
}

